import {createAction, props} from '@ngrx/store';
import {ChangelogState} from '@wba/store/models/changelog.state';

export enum ChangelogActionTypes {
  LOAD = '[CHANGELOG] Load Init',
  LOAD_SUCCESS = '[CHANGELOG] Load Success',
  LOAD_CACHED = '[CHANGELOG] Load Cached'
}

export const ChangelogLoadAction = createAction(ChangelogActionTypes.LOAD);
export const ChangelogLoadSuccessAction = createAction(ChangelogActionTypes.LOAD_SUCCESS, props<{ changelog: ChangelogState }>());
export const ChangelogLoadCachedAction = createAction(ChangelogActionTypes.LOAD_CACHED);
